import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import * as React from 'react';
import S from './CtaBlock.styles';
const CtaBlock = (props) => {
    return (React.createElement(S.Container, null,
        React.createElement("div", null,
            React.createElement(S.CtaBlockTitle, null, props.title),
            props.description && React.createElement(S.CtaBlockDescription, { dangerouslySetInnerHTML: { __html: props.description } })),
        React.createElement(LinkButton, { buttonType: "solid", href: props.cta.url, target: props.cta.target, icon: props.cta.icon }, props.cta.text)));
};
export default CtaBlock;
